import axios from 'axios';

export const myparticipate = async (userID, type) => {

    const response = await axios.put(`${process.env.REACT_APP_AWS_URL}/api/user/myparticipate`, { userID: userID, type: type });

    return response.data;

}